export default __webpack_public_path__ + "static/media/event2.6c0e566a.png";